import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

export const transactionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTransactions: builder.query({
      query: (params) => {
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(
            ([, value]) => value !== "" && value !== undefined && value !== null,
          ),
        );
        const queryParams = new URLSearchParams(filteredParams).toString();

        return {
          url: `transaction?${queryParams}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const { useGetAllTransactionsQuery } = transactionApi;
